import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getWalletDetailsRequest = {};
var _getWalletDetailsResponse = {};
var _issueStoreCreditRequest = {
    expirationDate: 'google.protobuf.Timestamp',
};
var _issueStoreCreditResponse = {
    walletAction: '_v1WalletAction',
    wallet: '_wallet',
};
var _v1WalletAction = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    startDate: 'google.protobuf.Timestamp',
    expirationDate: 'google.protobuf.Timestamp',
    disableDate: 'google.protobuf.Timestamp',
    walletActionStarted: '_walletActionExecutionDetails',
    walletActionEnded: '_walletActionExecutionDetails',
};
var _wallet = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _walletActionExecutionDetails = {
    executionDate: 'google.protobuf.Timestamp',
};
function resolveWixRiseIntegrationWixV1WixIntegrationServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/rise-wix-integration-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/rise-wix-integration-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/rise-wix-integration-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/rise-wix-integration-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/rise-wix-integration-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/rise-wix-integration-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/rise-wix-integration-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/rise-wix-integration-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Gets Wallet Details from rise.ai's Wallet service. */
export function getWalletDetails(payload) {
    var _a = serializer(_getWalletDetailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWalletDetailsResponse, {}).fromJSON;
    function __getWalletDetails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.integration.v1.wix_integration_provider',
            method: 'POST',
            methodFqn: 'wix.rise.integration.wix.v1.WixIntegrationService.GetWalletDetails',
            url: resolveWixRiseIntegrationWixV1WixIntegrationServiceUrl({
                protoPath: '/v1/wallet-details',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWalletDetails.fromReq = fromReq;
    __getWalletDetails.__isAmbassador = true;
    return __getWalletDetails;
}
/** Issues Store Credit to rise.ai's Wallet. */
export function issueStoreCredit(payload) {
    var _a = serializer(_issueStoreCreditRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_issueStoreCreditResponse, {
        _v1WalletAction: _v1WalletAction,
        _wallet: _wallet,
        _walletActionExecutionDetails: _walletActionExecutionDetails,
    }).fromJSON;
    function __issueStoreCredit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.rise.integration.v1.wix_integration_provider',
            method: 'POST',
            methodFqn: 'wix.rise.integration.wix.v1.WixIntegrationService.IssueStoreCredit',
            url: resolveWixRiseIntegrationWixV1WixIntegrationServiceUrl({
                protoPath: '/v1/issue-store-credit',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __issueStoreCredit.fromReq = fromReq;
    __issueStoreCredit.__isAmbassador = true;
    return __issueStoreCredit;
}
//# sourceMappingURL=http.impl.js.map